// src/context/AppEnvContext.js
import React, { createContext, useContext, useMemo } from 'react';

const AppEnvContext = createContext(null); // ✅ Changed from {} to null for better null checking

export const AppEnvProvider = ({ children }) => {
  // ✅ Added useMemo to prevent unnecessary recalculations
  const envVars = useMemo(() => {
    try {
      // ✅ Added null safety check for process.env
      if (!process?.env) {
        console.error("process.env is not available");
        return {};
      }

      const vars = Object.keys(process.env)
        .filter((key) => key?.startsWith('REACT_APP_')) // ✅ Added null safety
        .reduce((acc, key) => {
          acc[key] = process.env[key];
          return acc;
        }, {});

      return vars;
    } catch (error) {
      console.error("Error loading environment variables:", error);
      return {}; // ✅ Return empty object on error
    }
  }, []); // Empty dependency array since process.env doesn't change

  return (
    <AppEnvContext.Provider value={envVars}>
      {children}
    </AppEnvContext.Provider>
  );
};

export const useAppEnv = () => {
  const context = useContext(AppEnvContext);
  
  // ✅ Added warning if used outside provider
  if (context === null) {
    console.warn("useAppEnv must be used within AppEnvProvider");
    return {};
  }
  
  return context;
};